// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1YUQ6","disabled":"FileBtn_disabled__FJrow","warn":"FileBtn_warn__2j2I8","fade":"FileBtn_fade__2SUPJ"};